// extracted by mini-css-extract-plugin
module.exports =  {"title":"oPIyDB4bptUDK8Ws34vC"};